import Navbar from '../home/components/Navbar';
import Hero from './components/Hero';
import Content from './components/Content';
import FAQ from './components/FAQ';
import Footer from '../home/components/Footer';
import { useSchemaOrg, usePageMeta } from '../../utils/seo';

export default function UprightPianoRemovalLondon() {
  // Set page meta tags
  usePageMeta(
    'Upright Piano Removal London | From £149 | Specialist Movers',
    'Professional upright piano removal across London. All sizes moved with specialist equipment and trained crew. From £149 fully insured. Free fixed-price quote — 020 3441 9463.',
    'upright piano removal London, upright piano movers London, upright piano moving, piano stairs London',
    'https://www.pianomovers.co.uk/upright-piano-removal-london',
    'Upright Piano Removal London | From £149 | Specialist Movers',
    'Professional upright piano removal across London. All sizes, specialist equipment, trained crew. From £149 fully insured. Free quote — 020 3441 9463.',
    'Upright Piano Removal London | From £149',
    'Professional upright piano removal London. All sizes, from £149, fully insured. Free fixed-price quote — 020 3441 9463.'
  );

  // Add FAQ structured data
  useSchemaOrg({
    type: 'FAQPage',
    data: {
      mainEntity: [
        {
          '@type': 'Question',
          name: 'Can one person move an upright piano in London?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'No, one person should never attempt to move an upright piano in London. Even the smallest spinet upright weighs 90kg, while full-size overstrung uprights can weigh 300kg. A minimum of two trained specialists is required for safe upright piano removal. Professional piano movers use specialist equipment including piano boards, straps, and protective blankets. Attempting to move an upright piano alone risks serious personal injury and damage to the instrument worth thousands of pounds.',
          },
        },
        {
          '@type': 'Question',
          name: 'Will upright piano removal damage my floors?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Professional upright piano removal should not damage your floors when performed by specialists. Reputable piano movers in London use protective floor coverings, piano boards with rubber wheels, and proper lifting techniques to prevent floor damage. The main risk comes from dragging a piano across floors or using castors on delicate surfaces like hardwood or laminate. Always inform your piano removal company about your floor type in advance so they can bring appropriate protection.',
          },
        },
        {
          '@type': 'Question',
          name: 'My upright piano hasn\'t been moved in 20 years — is that a problem?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'An upright piano that hasn\'t been moved in 20 years requires extra care but can be safely relocated by specialist piano movers in London. Long-stationary pianos may have settled into the floor, have seized castors, or accumulated internal dust affecting the action. Professional movers will inspect the piano before moving, check for structural issues, and may recommend a piano technician inspection if the instrument is particularly valuable or old. The piano will likely need tuning 2-3 weeks after the move to allow it to acclimatise to its new environment.',
          },
        },
      ],
    },
  });

  return (
    <div className="bg-[#f5f5f0] text-[#1a1916]">
      <Navbar />
      <Hero />
      <Content />
      <FAQ />
      <div className="bg-[#1a1916] py-4 text-center">
        <p className="text-[#d4d4ce] text-xs">
          Piano Movers UK is an independent guide to piano removal services in London.
        </p>
      </div>
      <Footer />
    </div>
  );
}